import { RouteObject } from "react-router-dom"

import PayOrder from '../components/payCenter/PayOrder';
import PayOrderBak from '../components/payCenter/PayOrderBak';

const payRouters: RouteObject[] = [
    {
        path: "/payOrder",
        element: <PayOrder />,
    },
        {
        path: "/payOrderBak",
        element: <PayOrderBak />,
    },
];


export default payRouters;